var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75,
    height: 65,
    viewBox: "0 0 75 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.351,
    y1: 0.5,
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#61daff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25ccff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-folder-open",
    "data-name": "Icon ionic-ios-folder-open",
    transform: "translate(-2.252 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M68.6,13.882a3.724,3.724,0,0,0-3.806-3.923H32.36a1.221,1.221,0,0,1-1.018-.409L27.586,5.711l-.033-.034A3.59,3.59,0,0,0,24.665,4.5H8.623A4.01,4.01,0,0,0,4.5,8.423V20.875H68.6Z",
    transform: "translate(3.206)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M7.606,13.219H6.216c-2.143,0-4.236.86-3.935,4.1S6.216,52.851,6.216,52.851c.452,3,1.959,4.216,4.186,4.216H69.427c2.127,0,3.516-1.315,3.851-4.216,0,0,3.717-31.183,3.952-34.658.234-3.457-1.49-4.975-3.952-4.975H7.606Z",
    transform: "translate(0 12.432)",
    fill: "url(#linear-gradient)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.741de0e22c95ee521ec8626af1f594bf.svg";
export { ForwardRef as ReactComponent };